<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.44104,1.1042599403953552C8.17311,0.9652466403953552,7.82678,0.9652466403953552,7.559,1.1042599403953552L0.365126,4.999999940395355C-0.121709,5.252829940395356,-0.121709,5.747279940395355,0.365126,5.999999940395355L7.559,9.896059940395356C7.82678,10.035069940395354,8.17311,10.035069940395354,8.44104,9.896059940395356L14.005,6.882659940395355L14.0165,10.014159940395356C14.0185,10.561479940395355,14.4627,11.004099940395355,15.01,11.004099940395355C15.5568,11.004099940395355,16,10.560889940395356,16,10.014149940395356L16,5.500119940395355C16,5.3132899403953555,15.8783,5.126429940395355,15.6348,4.999999940395355L8.44104,1.1042599403953552ZM7.75802,11.478499940395356L3.3712,9.046789940395355C3.33412,9.026229940395355,3.29241,9.015439940395355,3.25,9.015439940395355C3.11193,9.015439940395355,3,9.127369940395356,3,9.265439940395355L3,12.220399940395355C3,12.313299940395355,3.05149,12.398499940395356,3.13371,12.441699940395356L7.76946,14.877699940395356C7.91508,14.954299940395355,8.08902,14.954299940395355,8.23463,14.877699940395356L12.8704,12.441699940395356C12.9526,12.398499940395356,13.0041,12.313299940395355,13.0041,12.220399940395355L13.0041,9.265299940395355C13.0041,9.222919940395355,12.9933,9.181239940395356,12.9728,9.144169940395356C12.9059,9.023389940395354,12.7537,8.979709940395356,12.6329,9.046619940395356L8.2427,11.478499940395356C8.09193,11.561999940395355,7.90877,11.561999940395355,7.75802,11.478499940395356Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Learning',
} as DefineComponent
</script>
